<template>
  <v-layout fill-height
            align-center
            justify-center
            :class="`${bgColor}`"
            wrap
            @click="!event.Disabled && show(event)">
            <p v-if="showBusyTimeBtn() && !event.Disabled && event.Status!='Confirmed'" class="mb-0 body-2" :class="event.Status=='Waited'? 'white--text':'blue-titles'">
              <input type="checkbox" :checked="event.Status=='Waited'" name="aa" class="mr-2"/>Peak Hours
            </p>
            <p v-if="(!event.Disabled && event.Type!='BusyTime') && (event.Status === 'Confirmed' || event.Status === 'Waited')" class="mb-0 body-2 font-weight-medium checkedStatus text-xs-center ">
              <span>{{event.StartTime | formatDate}}</span>

              <span v-if="event.IsBonusTime" @click.stop="">
                <v-tooltip bottom >
                  <template v-slot:activator="{ on }">
                    <i v-on="on"  class="material-icons money-icon">attach_money</i>
                  </template>
                  <span>Plotting schedule during this period of time will probably be rewarded with the bonus equal to {{event.BonusRate}} time of your hourly rate</span>
                </v-tooltip>
              </span>
            </p>
            <p v-if="(!event.Disabled && event.Type!='BusyTime') && (event.Status === 'Canceled') && (event.IsBonusTime)" class="mb-0 body-2 font-weight-medium checkedStatus text-xs-center ">

              <span v-if="event.IsBonusTime" @click.stop="" class="default-bonus">
                <v-tooltip bottom >
                  <template v-slot:activator="{ on }">
                    <i v-on="on"  class="material-icons money-icon">attach_money</i>
                  </template>
                  <span>Plotting schedule during this period of time will probably be rewarded with the bonus equal to {{event.BonusRate}} time of your hourly rate</span>
                </v-tooltip>
              </span>
            </p>
            <p v-else></p>

  </v-layout>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
import confirmDialog from '@/components/confirmDialog'
import { formatDate } from '@/utils/date.js'
import { getTutorLessonDurationTest } from '@/api/classtable'
import { getNextDate } from '@/utils/date.js'

import { isContinous } from '@/utils/date'
const namespace = 'release'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)
export default {
  props: ['info'],
  filters: { 
    formatDate (time) {
      //兼容mac客户端时间错乱
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent) 
      if(isMac){
        let date = time.replace("T"," ").replace(/-/g, "/")
        return formatDate(date, 'hh:mm')
      }else{
        let date = new Date(time)
        return formatDate(date, 'hh:mm')
      }
    }
   },

  watch:{
      
  },
  computed: {
    ...mapGetters(['collection', 'canSubmit', 'selects','modifyNextWeekNumber']),
    event () {
      return {
        ...this.info.event.extendedProps,
        Disabled: this.info.event.extendedProps.Disabled,
        StartTime: this.info.event.extendedProps.StartTime,
        EndTime: this.info.event.extendedProps.EndTime,
        Status: this.info.event.extendedProps.Status
      }
    },
    bgColor () {
        
      if (this.event.Disabled === true || (this.event.Type=='BusyTime' && this.event.Status=='Confirmed')) {
        return 'cursor-defaut grey lighten-2'  //不可选课
      } else if (this.event.Status === 'Waited') { //当前选课
        return 'current-ordere-course'
      } else if (this.event.Status === 'Canceled') { //可选课
        return 'optional-course'
      }else if (this.event.Type === 'Default' && this.event.Status === 'Confirmed') { //之前已订课
        return 'ordered-course'
      }else {
        return ''
      }
    },
    selects () {
      return this.$store.state[namespace].selects
    },
    canSubmit () {
      return this.$store.state[namespace].canSubmit
    }
  },
  // 试图在当前日历事件下操作整个日历的数据会使视图的反应变得极其慢
  methods: {
    showBusyTimeBtn(){

        if(this.event.Type=="BusyTime"){
            var eventIds=window.eventIds||[]
            var elId=`el${new Date(this.event.StartTime).getTime()}`
            var el=eventIds.filter(t=>t==elId)
            if(el && el.length>1){
                return false
            }
            eventIds.push(elId)
            window.eventIds=eventIds
            return true
        }
        return false
    },
    
    show (event) {
        let starTime = new Date(event.StartTime).getHours()
        let startDay = new Date(event.StartTime)
            if(event.Type == 'BusyTime'){
              let setStatus = ''
              if(event.Status === 'Canceled'){
                //设置全选
                setStatus = 'upBusyTime'
              }
              if(event.Status === 'Waited'){
                //设置全不选
                setStatus = 'upBusyTimeCancle'
              }
                // this.$store.dispatch(`${namespace}/${setStatus}`, event)
                
                this.$store.dispatch(`${namespace}/${setStatus}`, event.BusyTimeCheckFlag)

            //   let init = 18 
            //   let curDate = new Date(startDay.setDate(startDay.getDate()-1))
              
            //   for(let i = 0; i < 4; i++){
            //     curDate.setHours(init)
            //     let wholeClock = {StartTime: `${formatDate(curDate, 'yyyy-MM-ddThh:mm:ss')}`, EndTime:``, Disabled: false, Status: "Canceled"}
            //     let curDates = curDate.dateClone();
            //     curDates.setMinutes(30)   
            //     this.$store.dispatch(`${namespace}/${setStatus}`, wholeClock)
            //     let halfClock = {StartTime: `${formatDate(curDates, 'yyyy-MM-ddThh:mm:ss')}`, EndTime:``, Disabled: false, Status: "Canceled"}
            //     this.$store.dispatch(`${namespace}/${setStatus}`, halfClock)
            //     init++
            //   }

            }else{
            //   if(starTime >= 18 && starTime <= 22){
            //     let curCheck = startDay.dateClone();
            //     let aa = new Date(curCheck.setDate(curCheck.getDate() + 1))
            //     aa.setHours(0)
            //     aa.setMinutes(0)   
            //     let check = { Disabled: false, EndTime: ``, StartTime: `${formatDate(aa, 'yyyy-MM-ddT')}00:00:00`, Status: ""}
            //     // this.$store.dispatch(`${namespace}/upEvents`, check)
            //  }
              let nextMonday = getNextDate(-7)
              let nextSunday = getNextDate(-13)
              let beginDate = new Date(nextMonday+'T00:00:00')
              let endDate = new Date(nextSunday+'T24:00:00')
              let start = new Date(event.StartTime)

              if(this.modifyNextWeekNumber === 0 && (start >= beginDate && start <= endDate) && event.Status === "Canceled"){
                console.log('okk');
                this.$root.$alertTips('No modification for plotted schedule', '',{ icon: { default:true } });
                return
              }
              this.$store.dispatch(`${namespace}/upEvents`, event)
            }
      // if (this.selects.length >= this.maxClsss) {
      //   if (isContinous(this.selects, 'StartTime')) {
      //     !this.canSubmit || this.$store.dispatch(`${namespace}/setCanSubmit`, false)
      //     this.$parent.$root.$alertTips(this.errorType[0])
      //   } else {
      //     this.canSubmit || this.$store.dispatch(`${namespace}/setCanSubmit`, true)
      //   }
      // } else {
      //   this.canSubmit || this.$store.dispatch(`${namespace}/setCanSubmit`, true)
      // }
    }
  }
}
</script>
<style lang="scss">
  .cursor-defaut {
    cursor: default;
  }
  .aaaaa{
    background: red;
  }
  .current-ordere-course{
    background: #577EE3;
  }
  [data-theme="theme1"] .optional-course{
    background: #ececec ;
  }
  .optional-course{
    background: #fff;
  }
  .ordered-course{
    background: #577EE3;
  }
  .blue-titles{
    color: #32397A !important
  }
</style>
<style lang="scss">
  .checkedStatus{
      width: 70%;
    span {
      margin-top: 5px;
      color: #fff;
    }
    i {
      color: #3bd6a0;
      float: right;
      width: 24px;
    }
  }
  .default-bonus .material-icons.money-icon{
    color: #577ee3;
    border: 2px solid #577ee3;

  }
  .material-icons.money-icon{
    position: absolute;
    right: 11px;
    top: 11px;
    font-size: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    height: 16px;
    width: 16px;
    line-height: 16px;
    color: #fff;
  }

</style>
